import {Logger} from "~/services/logger"

/**
 * Enable sticky table headers and sync horizontal scrolling if table body overflows
 *
 * Place v-sticky-header on element that contains a `.table-header`
 * (and optionally contains a `.scroll-area` for horizontal scrolling)
 *
 * requires specific table and navbar structure - can be more generalized if needed
 * does not handle when pages is scrolled so far down the entire table is out of view
 *  -> header will continue to be stuck at top of viewport
 */
export default {
  inserted(el, binding, node) {
    const $tableHeader = $(el).find('.table-header')
    const $table = $(el).closest('[role="table"]')
    if (!$tableHeader.length) {
      Logger.errorOnce('StickyHeader', '.table-header not found.')
      return
    }
    if (!$table.length) {
      Logger.errorOnce('StickyHeader', '[role="table"] not found.')
      return
    }

    let isSticky = false
    const $window = $(window)
    const $scrollArea = $(el).closest('.scroll-area')
    let $navbar: { length: number, outerHeight(): number } = $('.navbar-content')
    // navbar not present in onestop - make a fake navbar so rest of code works
    if (!$navbar.length) $navbar = { length: 0, outerHeight: () => 0 }
    const $placeholder = $tableHeader.clone().css({ visibility: 'hidden' })

    const stickPosition = () => $navbar.outerHeight()
    const stickOffset = () => $window.scrollTop() + $navbar.outerHeight()
    const position = () => {
      return { top: `${stickPosition()}px`, left: `${$placeholder.offset().left}px`, width: `${$table.width()}px` }
    }
    const updatePosition = () => {
      if (isSticky) $tableHeader.css(position())
    }
    const shouldStick = () => {
      if (isSticky) {
        return $placeholder.offset().top <= stickOffset()
      } else {
        return $tableHeader.offset().top <= stickOffset()
      }
    }

    const updateSticky = () => {
      if (shouldStick()) {
        $tableHeader.addClass('sticky').after($placeholder)
        isSticky = true
        updatePosition()
      } else {
        isSticky = false
        $tableHeader.removeClass('sticky').css({ top: '', left: '', width: '' })
        $placeholder.remove()
      }
    }

    // handle when window is scrolled to stick headers to top of viewport when element is about to scroll up and out of view
    $(window).on('scroll.sticky-header', updateSticky)

    // handle when window is resized, need to recalculate position in case nav bar changes height or left/right scroll updates
    $(window).on('resize.sticky-header', updateSticky)

    // handle when scroll area scrolls left/right - keep headers in line with columns
    $scrollArea.on('scroll.sticky-header', updatePosition)

    updateSticky()
  },
  unbind(el, binding, node) {
    const $scrollArea = $(el).closest('.scroll-area')
    $(window).off('scroll.sticky-header, resize.sticky-header')
    $scrollArea.off('scroll.sticky-header')
  },
}